import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { dropdownItemDescription } from './itemDescription.vanilla.mjs';

const DropdownItemDescription = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(dropdownItemDescription, classNameFromProps);
  return /* @__PURE__ */ jsx(
    Primitive.p,
    {
      "data-scope": "dropdown",
      "data-part": "item-description",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});

export { DropdownItemDescription };
//# sourceMappingURL=ItemDescription.mjs.map
